<template>
    <piped-title
        :first="$t('apartments.apartment') + ' ' + apartment.number"
        :second="$t('apartments.settings')"
        :pages="breadcrumbPages"
    ></piped-title>

    <manage-topics
        :form="form"
        :suppliers="suppliers"
        :options="options"
        :type="'apartment'"
        :saveLink="route('advisors.apartments.updateTopics', apartment.uuid)"
        :goBackLink="route('advisors.apartments.show', apartment.uuid)"
    ></manage-topics>
</template>

<script>
import { defineComponent } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import PipedTitle from "@/Shared/Components/PipedTitle";
import { useForm } from "@inertiajs/inertia-vue3";
import PrimaryButton from "@/Jetstream/PrimaryButton";
import { ArrowLeftIcon, ExclamationIcon, TemplateIcon } from "@heroicons/vue/outline";
import ManageTopics from "@/Pages/Templates/Components/ManageTopics";

export default defineComponent({
    props: {
        apartment: Object,
        topics: Object,
        options: Array,
        suppliers: Array,
        projectName: String,
        projectUuid: String,
    },
    layout: MainLayout,
    components: {
        PipedTitle,
        PrimaryButton,
        ArrowLeftIcon,
        ExclamationIcon,
        TemplateIcon,
        ManageTopics,
    },
    setup(props) {
        const form = useForm({
            topics: props.topics.map((d) => d),
        });

        return {
            form,
        };
    },
    methods: {},
    computed: {
        breadcrumbPages() {
            return [
                {
                    name: this.$t("projects.projects"),
                    href: this.route("advisors.projects.index"),
                    current: false,
                },
                {
                    name: this.projectName,
                    href: this.route("advisors.projects.show", this.projectUuid),
                    current: false,
                },
                {
                    name: `${this.$t("apartments.apartment")} ${this.apartment.number}`,
                    href: this.route("advisors.apartments.show", this.apartment.uuid),
                    current: false,
                },
                {
                    name: `${this.$t("apartments.settings")}`,
                    href: "#",
                    current: true,
                },
            ];
        },
    },
});
</script>

<style scoped></style>
